// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';
import SideAccordion from 'wdna-components/lib/sidebar/components/SideAccordion';
import { TabConfig, addTab } from 'wdna-components/lib/tabs';
import { messageWarning } from 'wdna-components/lib/helpers/notification';

import { ContextType, FilterContext } from '../../../../../types';
import Container from '../../containers/Drilldown';

type Props = unknown

interface State {
  type?: string;
}

export default class DrilldownLoad extends React.Component<Props, State> {
  private mounted: boolean;

  public static contextType: React.Context<ContextType> = FilterContext;
  public context: React.ContextType<typeof FilterContext> | undefined;

  public constructor(props: Props) {
    super(props);

    this.mounted = false;

    this.state = {
      type: '',
    };
  }

  public componentDidMount(): void {
    this.mounted = true;
  }

  public componentWillUnmount(): void {
    this.mounted = false;
  }

  public setLocalState = (nextState: Partial<State>, callback?: (() => void)): void => {
    if (this.mounted) {
      this.setState((prevState: State) => ({
        ...prevState,
        ...nextState,
      }), callback);
    }
  };

  public clearSelection = (): void => {
    this.setLocalState({ type: undefined });
  };

  /* Handlers */
  public handleChanges = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    const { value, name } = e.target;
    this.setLocalState({ [name]: value });
  };

  public handleClick = (): void => {
    const { type } = this.state;

    const mainFilter: any = this.context?.parentState?.mainFilter;

    if (!type) {
      messageWarning('Error', 'Please select all parameters.');
    } else {
      const tabId: string = window.getStr();
      const dataTab1: TabConfig = {
        id: tabId,
        title: `Unload Details (${type})`,
        active: true,
        component: Container,
        props: {
          mainFilter,
          type,
        },
      };
      window.store.dispatch(addTab(dataTab1));
    }
  };

  public render(): JSX.Element {
    const { type } = this.state;

    const btnTitle: string = 'New Tab';

    const types: DataSelect2[] = [
      { id: 'ALL', text: 'All containers' },
      { id: 'SUW', text: 'Solid Urban Waste' },
      { id: 'FOR', text: 'Organic' },
      { id: 'PAP', text: 'Paper' },
      { id: 'PET', text: 'Plastic' },
      { id: 'GLA', text: 'Glass' },
      { id: 'PNG', text: 'Pruning' },
      { id: 'CRK', text: 'Crockery' },
    ];

    return (
      <div id="sidebar-lte-functions">
        <SideAccordion
          openedSign={'<i class="fa fa-minus-square-o"></i>'}
          closedSign={'<i class="fa fa-plus-square-o"></i>'}
          items={[
            {
              title: 'Unload details',
              id: 'kpi-drilldown-el',
              icon: 'wdna-ico-icon-drilldown',
              content: (
                <div className="drill-down-functions">
                  <div className="cl-element">
                    <Select2
                      name="type"
                      value={_.defaultTo(type, '')}
                      onChange={this.handleChanges}
                      data={types}
                      options={{ placeholder: 'Select Group Level' }}
                      style={{ width: '100%' }}
                    />
                  </div>
                  <div className="cl-element">
                    <button type="button" className="play-btn btn btn-default" onClick={this.handleClick}>
                      <i className="wdna-ico-icon-playsearch" />
                      <span> {btnTitle || 'Run'}</span>
                    </button>
                  </div>
                </div>
              ),
            },
          ]}
        />
      </div>
    );
  }
}
